// extracted by mini-css-extract-plugin
export default {"duration-field":"styles_duration-field__7wkOA","input-fields":"styles_input-fields__R-Ra7","input-field":"styles_input-field__BFf5H"};